exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mergebusinesss {\n  border: 1px solid red;\n}\ntr.el-table__row.row-payment {\n  background-color: #67c23a5e;\n}\ntr.el-table__row.row-dept {\n  background-color: #e6a23c96;\n}\ntr.el-table__row.row-archived div {\n  text-decoration: line-through;\n  color: black;\n}\n.search.x-row {\n  align-items: flex-start;\n}\n.title {\n  color: aliceblue;\n  text-align: center;\n}\n.has-more {\n  color: red;\n  font-weight: 700;\n}\n", ""]);

// exports
